import React from 'react';

import { useState, useEffect } from 'react';

import makeStyles from '@mui/styles/makeStyles';

import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import TextField from '@mui/material/TextField';

import { ReclamationActionDetailType } from 'constants.js';
import { ReclamationActionDetailCodes } from 'constants.js';

const useStyles = makeStyles((theme) => ({
    formControl: {
        width: '100%',
        marginBottom: theme.spacing(1)
    },
}));





/* Liste des réponses possibles */
const demandeLabel = "En cas de refus du devis de réparation, indiquer si";
const demandes = [
    'Frais de devis / prise en charge',
    'Conditions de retours sur devis refusé (machine démontée, ...) ou frais sup pour remontage ...',
];


export default function AnnulationDialogContent({ onChange, action }) {




    const classes = useStyles();

    const [demande, setDemande] = useState('');
    const [montant, setMontant] = useState('');


    useEffect(() => {
        onChange(null);
    }, [onChange]);


    useEffect(() => {


        const getActionData = () => {

            if (demande === '') {
                return null;
            }
            if (montant === '') {
                return null;
            }

            let actionData =
            {
                code: action.code,
                details: [
                    {
                        code: ReclamationActionDetailCodes.Resultat,
                        type: ReclamationActionDetailType.ChoixSimple,
                        libelle: demandeLabel,
                        position: 0,
                        valeurString: demandes[demande],
                        valeurInteger: demande
                    },
                    {
                        code: ReclamationActionDetailCodes.Resultat,
                        type: ReclamationActionDetailType.Flottant,
                        libelle: "Montant",
                        position: 1,
                        valeurFloat: montant
                    }]
            };



            return actionData;
        }


        onChange(getActionData());
    }, [action.code, onChange, demande, montant]);


    return (
        <DialogContent>

            <FormControl component="fieldset" className={classes.formControl}>
                <FormLabel component="legend">{demandeLabel}</FormLabel>
                <RadioGroup
                    value={demande.toString()}
                    onChange={e => setDemande(parseInt(e.target.value, 10))}
                >
                    {demandes.map((m, index) => (
                        <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={m} />
                    ))}

                </RadioGroup>
            </FormControl>


            <TextField
                className={classes.formControl}
                value={montant}
                onChange={e => setMontant(e.target.value)}
                variant={"filled"}
                label={"Montant"}
                type="number"
                inputProps={{ min: 0 }}
                required
            />

        </DialogContent>
    );

}

